var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFunnelX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.527 13c.422 0 .824-.224 1.045-.587a4.444 4.444 0 002.21.587 4.465 4.465 0 00.193-8.928l2.399-2.619C14.91.917 14.53 0 13.772 0H.853C.095 0-.285.917.251 1.454L4.875 6.5v3.45c0 .384.18.746.488.976L7.8 12.754c.226.17.48.246.727.246zm.004-1.221L6.094 9.95V6.026L1.689 1.219h11.247L9.982 4.442a4.467 4.467 0 00-2.67 4.09c0 1.185.465 2.26 1.219 3.06v.187zm3.25.002a3.254 3.254 0 01-3.25-3.25 3.254 3.254 0 013.25-3.25 3.254 3.254 0 013.25 3.25 3.254 3.254 0 01-3.25 3.25zm-3.254 1.22c.422 0 .824-.225 1.045-.588a4.444 4.444 0 002.21.587 4.465 4.465 0 00.193-8.928l2.399-2.619C14.91.917 14.53 0 13.772 0H.853C.095 0-.285.917.251 1.454L4.875 6.5v3.45c0 .384.18.746.488.976L7.8 12.754c.226.17.48.246.727.246zm.004-1.222L6.094 9.95V6.026L1.689 1.219h11.247L9.982 4.442a4.467 4.467 0 00-2.67 4.09c0 1.185.465 2.26 1.219 3.06v.187zm3.25.002a3.254 3.254 0 01-3.25-3.25 3.254 3.254 0 013.25-3.25 3.254 3.254 0 013.25 3.25 3.254 3.254 0 01-3.25 3.25z",
    id: "funnel-x_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.954 4.47L2.5 2.925l1.546 1.547a.1.1 0 00.142 0l.283-.283a.1.1 0 000-.142L2.924 2.5 4.471.954a.1.1 0 000-.142L4.188.53a.1.1 0 00-.142 0L2.5 2.076.954.529a.1.1 0 00-.142 0L.53.812a.1.1 0 000 .142L2.076 2.5.529 4.046a.1.1 0 000 .142l.283.283a.1.1 0 00.142 0zm0 0L2.5 2.925l1.546 1.547a.1.1 0 00.142 0l.283-.283a.1.1 0 000-.142L2.924 2.5 4.471.954a.1.1 0 000-.142L4.188.53a.1.1 0 00-.142 0L2.5 2.076.954.529a.1.1 0 00-.142 0L.53.812a.1.1 0 000 .142L2.076 2.5.529 4.046a.1.1 0 000 .142l.283.283a.1.1 0 00.142 0z",
    id: "funnel-x_svg__c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "funnel-x_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#funnel-x_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E24C4C",
    fillRule: "nonzero",
    xlinkHref: "#funnel-x_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24C4C",
    mask: "url(#funnel-x_svg__b)",
    d: "M0-2h16v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "funnel-x_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#funnel-x_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E24C4C",
    fillRule: "nonzero",
    xlinkHref: "#funnel-x_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24C4C",
    mask: "url(#funnel-x_svg__d)",
    d: "M-9-8H7V8H-9z"
  })))));
}

export default SvgFunnelX;